import React from 'react';
import QuickCustomerModal from './components/Modal';

interface Props {
    onClose: () => void;
    isOpen: boolean;
}

const QuickCustomer = ({onClose, isOpen}: Props) => {
    return isOpen && <QuickCustomerModal onClose={onClose} />;
};

export default QuickCustomer;
